import axios from 'api';
import jwtService from 'app/services/jwtService';
import { getCurrentApiUrl } from 'app/helpers';

require('dotenv').config();

const config = {
  headers: { Authorization: `bearer ${jwtService.getAccessToken()}` }
};
// axios.defaults.headers.common = {'Authorization': `Bearer ${token}`}

export const GET_HAIRDRESSERS = '[CONSOLE] GET SALONS';
export const RESET_HAIRDRESSERS_STORE = '[CONSOLE] RESET STORE';
export const GET_HAIRDRESSERS_BY_ID = '[CONSOLE] GET SALONS BY ID';
export const GET_HAIRDRESSERS_ERROR = '[CONSOLE] GET SALONS ERROR NETWORK';
export const SET_HAIRDRESSERS_SEARCH_TEXT = '[CONSOLE] SET SALONS SEARCH TEXT';

export const SET_BRAND_ID = '[CONSOLE] SET BRAND ID';
export const SET_COUNTRY_ID = '[CONSOLE] SET COUNTRY_ID';
export const SET_GROUP_ID = '[CONSOLE] SET GROUP_ID';
export const SET_DEPARTMENT_ID = '[CONSOLE] SET DEPARTMENT_ID';
export const SET_TYPE_ID = '[CONSOLE] SET TYPE_ID';
export const SET_ANIMATOR_ID = '[CONSOLE] SET ANIMATOR_ID';
export const SET_FRANCHISE_ID = '[CONSOLE] SET FRANCHISE_ID';
export const SET_OPENED = '[CONSOLE] SET OPENED';

export const START_LOADING = 'START_LOADING';
export const STOP_LOADING = 'STOP_LOADING';
export const SET_ERROR = 'SET_ERROR';

export function ImportFromXLSX(file) {
  const formData = new FormData();
  formData.append('file', file, file.name);

  return dispatch => {
    axios.post(`${getCurrentApiUrl()}/nationalPrices/import`, formData, {
      headers: {
        'Content-Type': `multipart/form-data;`
      }
    });
  };
}

export function getNationalCsv(
  brand_id,
  country_id,
  type_id,
  hairdresser_ids,
  setSuccessDownload,
  setFailureDownload
) {
  return async dispatch => {
    dispatch(startLoading());
    try {
      const response = await axios.post(
        `${getCurrentApiUrl()}/nationalPrices/export`,
        {
          brand_id,
          country_id,
          type_id,
          hairdresser_ids
        },
        {
          responseType: 'blob'
        }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'hairdressers_export.csv');
      document.body.appendChild(link);
      link.click();
      setSuccessDownload(true);
      setFailureDownload(false);
    } catch (error) {
      setFailureDownload(true);
      setSuccessDownload(false);
      // Handle error here
      console.error('Error in getNationalCsv:', error);
      dispatch(setError(error.message));
    } finally {
      dispatch(stopLoading());
    }
  };
}

export function getBusinessHours(brand_id, country_id, hairdresser_ids) {
  return dispatch => {
    const requestBody = {
      hairdresser_ids: hairdresser_ids
    };

    axios
      .post(`${getCurrentApiUrl()}/hairdressers/export/hours`, requestBody, {
        responseType: 'blob'
      })
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'hairdressers_export.csv');
        document.body.appendChild(link);
        link.click();
      });
  };
}

export function getCsv(brand_id, country_id, type_id) {
  return dispatch => {
    dispatch(startLoading());
    axios
      .get(
        `${getCurrentApiUrl()}/hairdressers/export?brand_id=${
          brand_id || null
        }&country_id=${country_id || null}&type_id=${type_id || null}`,
        { responseType: 'blob' }
      )
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'hairdressers_export.csv');
        document.body.appendChild(link);
        link.click();
      })
      .catch(error => {
        // Gestion des erreurs
        dispatch(setError(error.message));
        console.error('Error in getCsv:', error);
      })
      .finally(() => {
        // Fin du chargement, succès ou erreur
        dispatch(stopLoading());
      });
  };
}

export const startLoading = () => ({ type: 'START_LOADING' });
export const stopLoading = () => ({ type: 'STOP_LOADING' });
export const setError = error => ({ type: 'SET_ERROR', payload: error });

export function getHairdressers(params) {
  const request = axios.get(`${getCurrentApiUrl()}/hairdressers`, { params });

  return dispatch =>
    request
      .then(response => {
        dispatch({
          type: GET_HAIRDRESSERS,
          payload: response.data
        });
      })
      .catch(error => {
        dispatch({
          type: GET_HAIRDRESSERS_ERROR,
          payload: {
            status: 'error'
          }
        });
      });
}

export function resetHairdressers() {
  return {
    type: RESET_HAIRDRESSERS_STORE
  };
}

export function getHairdressersByBrandId(brand_id) {
  const request = axios.get(
    `${getCurrentApiUrl()}/hairdressers/brand/${brand_id}`,
    {},
    config
  );
  return dispatch =>
    request
      .then(response => {
        dispatch({
          type: GET_HAIRDRESSERS_BY_ID,
          payload: response.data
        });
      })
      .catch(error => {
        dispatch({
          type: GET_HAIRDRESSERS_ERROR,
          payload: {
            status: 'error'
          }
        });
      });
}

export function setHairdressersSearchText(event) {
  return {
    type: SET_HAIRDRESSERS_SEARCH_TEXT,
    searchText: event.target.value
  };
}

export function setBrandId(brand_id) {
  return {
    type: SET_BRAND_ID,
    brand_id
  };
}

export function setOpened(opened) {
  return {
    type: SET_OPENED,
    opened
  };
}

export function setCountryId(country_id) {
  return {
    type: SET_COUNTRY_ID,
    country_id
  };
}

export function setGroupId(group_id) {
  return {
    type: SET_GROUP_ID,
    group_id
  };
}

export function setType(type_id) {
  return {
    type: SET_TYPE_ID,
    type_id
  };
}

export function setDepartmentId(department_id) {
  return {
    type: SET_DEPARTMENT_ID,
    department_id
  };
}

export function setAnimatorId(animator_id) {
  return {
    type: SET_ANIMATOR_ID,
    animator_id
  };
}

export function setFranchiseId(franchise_id) {
  return {
    type: SET_FRANCHISE_ID,
    franchise_id
  };
}
